import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ExpertQuote() {
  return <section className="w-full py-12 px-4 md:px-8" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative pl-8 md:pl-12 py-4 border-l-4 border-forestGreen" data-id="element-56">
          <Quote className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 text-forestGreen/20 bg-cream" size={48} data-id="element-57" />

          <p className="font-serif text-xl md:text-2xl text-gray-800 leading-relaxed italic mb-6" data-id="element-58">
            "Chronisches Pfotenlecken wird oft als Hautproblem behandelt – dabei
            liegt die Ursache häufig im Darm. Eine gestörte Darmflora kann
            systemische Entzündungen auslösen die sich an Pfoten, Haut und Fell
            zeigen."
          </p>

          <div className="flex items-center gap-4" data-id="element-59">
            <div className="w-12 h-12 rounded-full bg-forestGreen/10 flex items-center justify-center text-forestGreen font-bold font-serif" data-id="element-60">
              NS
            </div>
            <div data-id="element-61">
              <p className="font-bold font-serif text-gray-900" data-id="element-62">
                Dr. Nane Schomburg
              </p>
              <p className="text-warmBrown text-sm font-serif" data-id="element-63">Tierärztin</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}